export default __webpack_public_path__ + "static/media/landing-Word-Objeto1.71a40bd1.webp";